import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.duplicateGuarantorError.title',
        defaultMessage: 'Please take off your additional guarantor'
    },
    message: {
        id: '_.automatedLendingDecision.decisionError.duplicateGuarantorError.message',
        defaultMessage: "We don't accept them for Sole Trader applications."
    }
});
